import $ from 'jquery';

class GeneralMeeting {


    init() {

        function classToggle(e) {


            const element = this;
            const parent = element.parentElement;

            parent.classList.toggle('active');

        }

        // function classToggle(e) {
        //
        //     e.preventDefault();
        //
        //     const element = this;
        //     const parent = element.parentElement;
        //
        //     parent.classList.toggle('active');
        //
        // }

        function clickActiveTab(e) {

            e.preventDefault();

            const element = this;
            const parent = element.parentElement;
            const tabHash = this.hash;


            $('.gm__menu-item.active').removeClass('active');

            parent.classList.toggle('active');



            if (!tabHash.length) return;
            e.preventDefault();

            if (typeof (window.history.pushState) == 'function' ) {
                window.history.pushState(null, tabHash, tabHash);
            } else {
                window.location.hash = tabHash;
            }


            showTab();
        }


        function showTab(e) {

            const hashItem = window.location.hash;
            const gm__menu = document.querySelector('gm__menu');

            let elementHash = window.location.hash;

            let hashParent = $('.gm__menu-item a[href*="' + elementHash + '"]').parent();


            if (elementHash.length > 0) {
                let $elementHash = $(elementHash);

                hashParent.closest('ul').find('.active').removeClass('active');
                hashParent.addClass('active');

                if ($elementHash.length) {
                    $elementHash.closest(".gm__tabs").find('.gm__tab.active').removeClass('active');
                    $elementHash.addClass('active');

                }
            }


        }


        const elements = document.querySelectorAll('.gm__tabs-header');

        [...elements].map(function (item) {

            item.addEventListener('click', classToggle, false);

        })


        const tabs = document.querySelectorAll('.gm__menu-url');

        [...tabs].map(function (item) {

            item.addEventListener('click', clickActiveTab, false);

        })


        window.addEventListener('DOMContentLoaded', showTab, false );

    }


}

export default GeneralMeeting;
